import { IRIS_PAGE_LOAD_REQUEST } from '../actionTypes/IrisActionTypes';

export const getIrisTemplateData = (
    params,
    aggregateAPI,
    postProcessor,
    irisFallbackEnabled,
    irisFallbackPreferences,
    redirectAction,
    disableIrisCall,
    initialLoad = true,
    showErrorPage = true
) => ({
    type: IRIS_PAGE_LOAD_REQUEST,
    payload: {
        params,
        aggregateAPI,
        postProcessor,
        irisFallbackEnabled,
        irisFallbackPreferences,
        redirectAction,
        disableIrisCall,
        initialLoad,
        showErrorPage,
    },
});

export default {
    getIrisTemplateData,
};
